'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = normalizeMinutes;

var _isNumber = require('./isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function normalizeMinutes(value) {
  if ((0, _isNumber2["default"])(value)) {
    var number = Number(value);

    if (number < 10) {
      return '0' + number;
    }

    return String(number);
  }

  return '';
}